import { Button } from 'loyal-react'
import { SelectMobileOperator } from '../../SelectMobileOperator'
import PropTypes from 'prop-types'
import React from 'react'

const OperatorStep = props => (
  <div className='bx-recarga bg-white radius row px-2 mx-0 pt-3 pb-2'>
    <div className='col-12 my-3 pb-1'>
      <h4 className='txt-uppercase color-brand-6 txt-body-sm mb-1'>
        Recarga de celular
      </h4>
      <h2 className='color-ui-white txt-title txt-circular-book'>
        Troque seus {props.pointsValue}
        <br />
        por crédito no celular.
      </h2>
    </div>
    <SelectMobileOperator
      id='operadora'
      label='Operadora'
      className='form-field col-12 mt-3 mt-md-5'
      value={props.operatorKey}
      onChange={props.onChangeMobileOperator}
      style={{ marginTop: '39px !important' }}
    />
    <Button
      id={'btnNextStepRecharge'}
      name={'NextStepRecharge'}
      className='btn-featured btn btn-sm mt-2 mx-1'
      text='Continuar'
      onClick={props.nextStep}
      disabled={!props.operatorKey}
    />
  </div>
)

OperatorStep.propTypes = {
  operatorKey: PropTypes.string,
  onChangeMobileOperator: PropTypes.func,
  nextStep: PropTypes.func,
  pointsValue: PropTypes.string
}

export default OperatorStep



// WEBPACK FOOTER //
// ./src/features/Services/RechargePhone/OperatorStep.js